type ThemeColors = {
  primary?: string
  on_primary?: string
  primary_container?: string
  on_primary_container?: string
  secondary?: string
  on_secondary?: string
  secondary_container?: string
  on_secondary_container?: string
  surface?: string
  on_surface?: string
  on_surface_variant?: string
  inverse_surface?: string
  inverse_on_surface?: string
  inverse_primary?: string
}

export type Theme = ThemeColors & {
  black?: string
  white?: string
  blue?: {
    700?: string
    600?: string
    500?: string
    100?: string
  }
  red?: {
    500?: string
  }
  authimg?: string
  authlogo?: string
  login_screen?: {
    color?: string
    title?: string
    statement?: string
  }
  logosymbol?: string
  login_headline?: string
  login_description?: string
  login_color?: string
  intro?: string
  refereshWithHost?: (host: string) => void
}

export const DEFAULT_THEME: Theme = {
  primary: "#372BC5",
  on_primary: "#FFFEFA",
  primary_container: "#CFCEFF",
  on_primary_container: "#0B0B26",
  secondary: "#5C5C6E",
  on_secondary: "#FFFEFA",
  secondary_container: "#DFDEFF",
  on_secondary_container: "#0B0B26",
  surface: "#F5F5FF",
  on_surface: "#0B0B26",
  on_surface_variant: "#5C5C6E",
  inverse_surface: "#34344A",
  inverse_on_surface: "#FFFEFA",
  inverse_primary: "#D7D5F3",
  black: "#000",
  white: "#fff",
  blue: {
    700: "#1485E2",
    600: "#436485",
    500: "#5cadff",
    100: "#f1f6fc",
  },
  red: {
    500: "#a54242",
  },
  authimg: 'url("/ft-bg-login.jpg")',
  authlogo: 'url("/flextribe-logo_black.svg")',
  logosymbol: 'url("/flextribe-symbol.svg")',
  login_screen: {
    color: "text-white",
    title: "Digitalize the way of working with your external workforce",
    statement: "",
  },
}

export const resolveTheme = (theme?: Theme | null): Theme => {
  if (!theme || Object.keys(theme).length === 0) return DEFAULT_THEME
  return theme
}
